<template>
  <p v-if="!!value" class="mb-1 ps-4">
    <b>{{ customField.name }}:</b> {{ value }}
  </p>
</template>

<script>
export default {
  name: "CustomFieldValues",
  props: {
    value: String,
    customField: {
      type: Object,
      required: true
    }
  }
};
</script>
